import Cropper from "./CropperX"

export default Cropper
